import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslatePipe } from '@ngx-translate/core';
import { TreeNode } from '../tree-container/tree-container.component';

@Component({
   
  selector: 'siat-node-item',
  templateUrl: './node-item.component.html',
  styleUrls: ['./node-item.component.scss'],
  imports: [
    CommonModule,
    MatTooltipModule,
    MatIconModule,
    MatButtonModule,
    MatMenuModule,
    TranslatePipe,
  ],
})
export class NodeItemComponent {
  /**
   * The node input.
   */
  @Input()
  node: TreeNode;

  /**
   * Emits an event when a node is toggled.
   */
  @Output()
  toggleEvent = new EventEmitter<TreeNode>();

  /**
   * Emits an event when delete button is clicked.
   */
  @Output()
  onClickUpdateNodeEventEmitter = new EventEmitter<TreeNode>();

  /**
   * Emits an event when delete button is clicked.
   */
  @Output()
  onClickDeleteNodeEventEmitter = new EventEmitter<TreeNode>();

  /**
   * Emit an event when add node button is clicked.
   */
  @Output()
  addNodeClick = new EventEmitter<void>();

  /**
   * Arrow color.
   */
  @Input()
  arrowColor: string;

  /**
   * On delete click.
   */
  onClickUpdateNode(event: Event): void {
    event.stopImmediatePropagation();
    event.preventDefault();

    this.onClickUpdateNodeEventEmitter.emit();
  }

  /**
   * On delete click.
   */
  onClickDeleteNode(event: Event): void {
    event.stopImmediatePropagation();
    event.preventDefault();

    this.onClickDeleteNodeEventEmitter.emit();
  }

  /**
   * On click node.
   */
  onClickNode(event: Event, node?: TreeNode): void {
    event.stopImmediatePropagation();
    event.preventDefault();

    if (node) {
      this.toggleEvent.emit(node);
    } else {
      this.addNodeClick.emit();
    }
  }
}
